export const KEY = 'sites';

export const SELECTED_PARAM_KEY = 'siteIds';
export const EXCLUDED_PARAM_KEY = 'excludeSiteIds';

// More action types.
export const SET_IS_EXCLUDED = 'SET_IS_EXCLUDED';
export const SET_IS_DISABLED = 'SET_IS_DISABLED';
